import oc from "open-color";

export function convertSecondsToTime(timeSec: number | undefined): string {
    if (timeSec === undefined) {
        return "--:--";
    }
    if (timeSec < 0) {
        timeSec = timeSec * -1;
    }
    const hours = Math.floor(timeSec / 3600)
        .toString()
        .padStart(2, "0");
    const minutes = Math.floor((timeSec % 3600) / 60)
        .toString()
        .padStart(2, "0");
    return `${hours}:${minutes}`;
}

export function convertDateToFormatedDateStr(date: Date): string {
    return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date
        .getDate()
        .toString()
        .padStart(2, "0")}`;
}

export function dateToFormatedDateTime(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}`;
}

export function toU32(regLow: string | undefined, regHigh: string | undefined): number {
    if (regLow !== undefined && regHigh !== undefined) {
        return Number(regLow) + Number(regHigh) * 0x10000;
    } else {
        return NaN;
    }
}

export async function delay(ms: number): Promise<void> {
    return new Promise<void>((resolve) => window.setTimeout(resolve, ms));
}

export function isMarkerValueMatchCondition(
    onValue: number,
    compareOperation: "=" | "<" | ">",
    markerValue?: string,
): boolean {
    if (markerValue === "" || markerValue === undefined || markerValue === "NORT") {
        return false;
    }

    switch (compareOperation) {
        case ">":
            return Number(markerValue) > onValue;
        case "<":
            return Number(markerValue) < onValue;
        default:
            return Number(markerValue) === onValue;
    }
}

export function deductColorFromSettings(color: string): string {
    if (color.startsWith("#")) {
        return color;
    }
    const parts = color.split(".");
    return (oc as unknown as Record<string, string[]>)[parts[0]][Number(parts[1])];
}
